import { render, staticRenderFns } from "./Crowd.vue?vue&type=template&id=6284c9df&scoped=true&"
import script from "./Crowd.vue?vue&type=script&lang=js&"
export * from "./Crowd.vue?vue&type=script&lang=js&"
import style0 from "./Crowd.vue?vue&type=style&index=0&id=6284c9df&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6284c9df",
  null
  
)

export default component.exports